import React from 'react';
import { components } from 'react-select';
const MultiValueRemove = (props) => {
  const newProps = {
    ...props,
    innerProps: {
      ...props.innerProps,
      className: `${props.innerProps.className} hs-multi-value-remove`,
    },
  };
  return <components.MultiValueRemove {...newProps} />;
};

export default MultiValueRemove;
